export {
  SlideoutOverviewSection,
  type SlideoutOverviewSectionProps
} from './SlideoutOverviewSection';
export {
  SlideoutGeneralInfoSection,
  SlideoutPhasedGeneralInfo,
  type SlideoutGeneralInfoSectionProps,
  type SlideoutPhasedGeneralInfoProps
} from './SlideoutGeneralInfoSection';
export {
  SlideoutFeaturesContainerSection,
  SlideoutLegacyFeaturesTab,
  type SlideoutFeaturesContainerSectionProps,
  type SlideoutLegacyFeaturesTabProps
} from './SlideoutFeaturesSection';
export {
  SlideoutMilestoneMatrix,
  SlideoutInheritedMilestonesPlaceholder,
  SlideoutMilestoneSortDropdown,
  SlideoutMilestoneMenuSlot,
  SlideoutMilestoneSortAndMenu,
  SlideoutMilestoneAccordionHeader,
  SlideoutMilestoneAddFooterSlot,
  type SlideoutMilestoneMatrixProps,
  type SlideoutMilestoneMatrixSortProps,
  type SlideoutMilestoneSortDropdownProps,
  type SlideoutMilestoneMenuSlotProps,
  type SlideoutMilestoneSortAndMenuProps,
  type SlideoutMilestoneAccordionHeaderProps,
  type SlideoutMilestoneAddFooterSlotProps
} from './SlideoutMilestonesSection';
export {
  SlideoutHeaderShell,
  SlideoutNotificationBell,
  type SlideoutHeaderShellProps,
  type SlideoutNotificationBellProps
} from './SlideoutHeaderShell';
export {
  SlideoutNonPhasedLayoutSection,
  type SlideoutNonPhasedLayoutSectionProps
} from './SlideoutNonPhasedLayoutSection';
export {
  SlideoutCustomAccordionSection,
  type SlideoutCustomAccordionSectionProps,
  type NormalizedPhase
} from './SlideoutCustomAccordionSection';
export {
  SlideoutMainContentSection,
  type SlideoutMainContentSectionProps
} from './SlideoutMainContentSection';

/** @deprecated Use SlideoutOverviewSection */
export { SlideoutOverviewSection as OverviewSectionContainer } from './SlideoutOverviewSection';
/** @deprecated Use SlideoutGeneralInfoSection */
export { SlideoutGeneralInfoSection as InfoSectionContainer } from './SlideoutGeneralInfoSection';
/** @deprecated Use SlideoutLegacyFeaturesTab */
export { SlideoutLegacyFeaturesTab as FeaturesSectionContainer } from './SlideoutFeaturesSection';
